export const downloadPageTranslations = {
  SUPPORTED_LANGUAGE_CODES: [
    'en',
    'es',
    'fr',
    'de',
    'it',
    'pt',
    'zh',
    'ja',
    'ko',
    'ar',
    'vi',
    'nl',
    'ca',
    'az',
    'bg',
    'hr',
    'cs',
    'da',
    'et',
    'fil',
    'fi',
    'el',
    'he',
    'hu',
    'id',
    'lv',
    'lt',
    'nb',
    'pl',
    'pt-BR',
    'ro',
    'ru',
    'sk',
    'sl',
    'sv',
    'th',
    'tr',
    'uk',
    'zh-HK',
    'zh-TW',
  ],
  en: {
    scanFirstLine: 'Scan QR code',
    scanSecondLine: 'to add pass to Wallet',
    building: 'Building your pass...',
    alreadyAddedGoogle: 'Pass has already been added to Google Wallet',
    alreadyAddedApple: 'Pass has already been added to Apple Wallet',
    notFound: 'Pass with this ID not found',
    passDeactivated: 'Pass has been deactivated',
    generalError: 'Something went wrong, please try again later',
    successMessage:
      'You should be redirected to your pass shortly. Please add it to your wallet.',
    goToWalletGoogle: 'GO TO GOOGLE WALLET',
    goToWalletApple: 'GO TO APPLE WALLET',
    defaultTitle: 'Add pass to Wallet',
    facingIssues: 'Facing issues?',
    tryAgain: 'Try again',
  },
  es: {
    scanFirstLine: 'Escanear código QR',
    scanSecondLine: 'para agregar el pase a la billetera',
    building: 'Construyendo tu pase...',
    alreadyAddedGoogle: 'El pase ya ha sido agregado a Google Wallet',
    alreadyAddedApple: 'El pase ya ha sido agregado a Apple Wallet',
    notFound: 'No se encontró el pase con este ID',
    passDeactivated: 'El pase ha sido desactivado',
    generalError: 'Algo salió mal, por favor inténtalo de nuevo más tarde',
    successMessage:
      'En breve serás redirigido a tu pase. Agrégalo a tu billetera.',
    goToWalletGoogle: 'IR A GOOGLE WALLET',
    goToWalletApple: 'IR A APPLE WALLET',
    defaultTitle: 'Agregar pase a la billetera',
    facingIssues: 'Experimentando problemas?',
    tryAgain: 'Inténtalo de nuevo',
  },
  fr: {
    scanFirstLine: 'Scannez le code QR',
    scanSecondLine: 'pour ajouter le pass à Wallet.',
    building: 'Création de votre pass...',
    alreadyAddedGoogle: 'Le pass a déjà été ajouté à Google Wallet.',
    alreadyAddedApple: 'Le pass a déjà été ajouté à Apple Wallet.',
    notFound: 'Pass avec cet identifiant introuvable.',
    passDeactivated: 'Le pass a été désactivé.',
    generalError: "Une erreur s'est produite, veuillez réessayer plus tard.",
    successMessage:
      "Vous devriez être redirigé vers votre pass sous peu. Veuillez l'ajouter à votre portefeuille.",
    goToWalletGoogle: 'ALLER SUR GOOGLE WALLET',
    goToWalletApple: 'ALLER SUR APPLE WALLET',
    defaultTitle: 'Ajouter le pass à Wallet',
    facingIssues: 'Vous rencontrez des difficultés ?',
    tryAgain: 'Réessayez',
  },
  de: {
    scanFirstLine: 'QR-Code scannen',
    scanSecondLine: 'Digitalen Pass zur Geldbörse hinzufügen',
    building: 'Erstellen Sie Ihren digitalen Pass...',
    alreadyAddedGoogle:
      'Der digitale Pass wurde bereits zu Google Wallet hinzugefügt.',
    alreadyAddedApple:
      'Der digitale Pass wurde bereits zu Apple Wallet hinzugefügt',
    notFound: 'Digitaler Pass mit dieser ID nicht gefunden',
    passDeactivated: 'Der digitaler Pass wurde deaktiviert',
    generalError:
      'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
    successMessage:
      'Sie sollten in Kürze zu Ihrem Pass weitergeleitet werden. Bitte fügen Sie ihn Ihrer Brieftasche hinzu.',
    goToWalletGoogle: 'ZU GOOGLE WALLET GEHEN',
    goToWalletApple: 'ZU APPLE WALLET GEHEN',
    defaultTitle: 'Digitaler Pass zu Wallet hinzufügen',
    facingIssues: 'Haben Sie Probleme?',
    tryAgain: 'Versuchen Sie es erneut',
  },
  it: {
    scanFirstLine: 'Scansiona il codice QR',
    scanSecondLine: 'per aggiungere il pass al Wallet',
    building: 'Creazione del pass in corso...',
    alreadyAddedGoogle: 'Il pass è già stato aggiunto a Google Wallet',
    alreadyAddedApple: 'Il pass è già stato aggiunto ad Apple Wallet',
    notFound: 'Pass con questo ID non trovato',
    passDeactivated: 'Il pass è stato disattivato',
    generalError: 'Si è verificato un errore, riprova più tardi',
    successMessage:
      'Dovresti essere reindirizzato al tuo pass a breve. Aggiungilo al tuo wallet.',
    goToWalletGoogle: 'VAI A GOOGLE WALLET',
    goToWalletApple: 'VAI A APPLE WALLET',
    defaultTitle: 'Aggiungi pass al Wallet',
    facingIssues: 'Problemi?',
    tryAgain: 'Riprova',
  },
  pt: {
    scanFirstLine: 'Escaneie o código QR',
    scanSecondLine: 'para adicionar o passe ao Wallet',
    building: 'Construindo o seu passe...',
    alreadyAddedGoogle: 'A passagem já foi adicionada ao Google Wallet',
    alreadyAddedApple: 'A passagem já foi adicionada ao Apple Wallet',
    notFound: 'Passagem com este ID não encontrada',
    passDeactivated: 'O passe foi desativado',
    generalError: 'Algo deu errado, por favor, tente novamente mais tarde',
    successMessage:
      'Você será redirecionado para o seu passe em breve. Por favor, adicione-o à sua carteira.',
    goToWalletGoogle: 'IR PARA O GOOGLE WALLET',
    goToWalletApple: 'IR PARA O APPLE WALLET',
    defaultTitle: 'Adicionar ao Carteira',
    facingIssues: 'Enfrentando problemas?',
    tryAgain: 'Tente novamente',
  },
  zh: {
    scanFirstLine: '扫描二维码',
    scanSecondLine: '将通行证添加到钱包',
    building: '正在生成您的通行证...',
    alreadyAddedGoogle: '通行证已成功添加到Google钱包',
    alreadyAddedApple: '通行证已成功添加到Apple钱包',
    notFound: '未找到该ID的通行证',
    passDeactivated: '通行证已失效',
    generalError: '操作出现错误，请稍后再试',
    successMessage: '您将很快被重定向到您的通行证。请将其添加到钱包。',
    goToWalletGoogle: '前往 Google 钱包',
    goToWalletApple: '前往 Apple 钱包',
    defaultTitle: '将通行证添加到钱包',
    facingIssues: '遇到问题？',
    tryAgain: '请重新尝试',
  },
  ja: {
    scanFirstLine: 'QRコードをスキャン',
    scanSecondLine: 'ウォレットにパスを追加',
    building: 'パスを作成中...',
    alreadyAddedGoogle: 'パスは既にGoogle Walletに追加されています',
    alreadyAddedApple: 'パスは既にApple Walletに追加されています',
    notFound: 'このIDのパスが見つかりません',
    passDeactivated: 'パスは無効化されています',
    generalError: 'エラーが発生しました。後ほど再試行してください',
    successMessage:
      'すぐにパスにリダイレクトされます。ウォレットに追加してください。',
    goToWalletGoogle: 'Google Walletへ移動',
    goToWalletApple: 'Apple Walletへ移動',
    defaultTitle: 'パスをウォレットに追加',
    facingIssues: '問題が発生していますか？',
    tryAgain: 'もう一度お試しください',
  },
  ko: {
    scanFirstLine: 'QR 코드를 스캔하세요',
    scanSecondLine: '지갑에 패스를 추가하세요',
    building: '패스를 생성 중입니다...',
    alreadyAddedGoogle: '이 패스는 이미 Google Wallet에 추가되었습니다',
    alreadyAddedApple: '이 패스는 이미 Apple Wallet에 추가되었습니다',
    notFound: '이 ID로 된 패스가 발견되지 않았습니다',
    passDeactivated: '이 패스는 비활성화되었습니다',
    generalError: '오류가 발생했습니다. 나중에 다시 시도해 주세요',
    successMessage: '곧 패스로 이동됩니다. 지갑에 추가해 주세요.',
    goToWalletGoogle: '구글 지갑으로 이동',
    goToWalletApple: '애플 지갑으로 이동',
    defaultTitle: '패스를 지갑에 추가',
    facingIssues: '문제가 발생하셨나요?',
    tryAgain: '다시 시도해 주세요',
  },
  ar: {
    scanFirstLine: 'امسح رمز الاستجابة السريعة',
    scanSecondLine: 'لإضافة البطاقة إلى المحفظة',
    building: 'جاري إنشاء بطاقتك...',
    alreadyAddedGoogle: 'تمت إضافة البطاقة بالفعل إلى Google Wallet',
    alreadyAddedApple: 'تمت إضافة البطاقة بالفعل إلى Apple Wallet',
    notFound: 'لم يتم العثور على البطاقة بهذه المعرف',
    passDeactivated: 'تم تعطيل البطاقة',
    generalError: 'حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقًا',
    successMessage: 'سيتم توجيهك إلى بطاقتك قريبًا. يرجى إضافتها إلى محفظتك.',
    goToWalletGoogle: 'انتقل إلى محفظة Google',
    goToWalletApple: 'انتقل إلى محفظة Apple',
    defaultTitle: 'أضف البطاقة إلى المحفظة',
    facingIssues: 'هل تواجه مشكلات؟',
    tryAgain: 'حاول مرة أخرى',
  },
  vi: {
    scanFirstLine: 'Quét mã QR',
    scanSecondLine: 'để thêm thẻ vào Ví',
    building: 'Đang tạo thẻ của bạn...',
    alreadyAddedGoogle: 'Thẻ đã được thêm vào Google Wallet',
    alreadyAddedApple: 'Thẻ đã được thêm vào Apple Wallet',
    notFound: 'Thẻ với ID này không được tìm thấy',
    passDeactivated: 'Thẻ đã bị vô hiệu hóa',
    generalError: 'Có sự cố xảy ra, vui lòng thử lại sau',
    successMessage:
      'Bạn sẽ được chuyển hướng đến thẻ của mình trong giây lát. Vui lòng thêm nó vào ví của bạn.',
    goToWalletGoogle: 'ĐI ĐẾN GOOGLE WALLET',
    goToWalletApple: 'ĐI ĐẾN APPLE WALLET',
    defaultTitle: 'Thêm thẻ vào Ví',
    facingIssues: 'Gặp sự cố?',
    tryAgain: 'Hãy thử lại',
  },
  nl: {
    scanFirstLine: 'Scan de QR-code',
    scanSecondLine: 'om de pas toe te voegen aan Wallet',
    building: 'Je pas wordt aangemaakt...',
    alreadyAddedGoogle: 'De pas is al toegevoegd aan Google Wallet',
    alreadyAddedApple: 'De pas is al toegevoegd aan Apple Wallet',
    notFound: 'Pas met deze ID niet gevonden',
    passDeactivated: 'De pas is gedeactiveerd',
    generalError: 'Er is iets misgegaan, probeer het later opnieuw',
    successMessage:
      'Je wordt zo doorgestuurd naar je pas. Voeg deze toe aan je wallet.',
    goToWalletGoogle: 'GA NAAR GOOGLE WALLET',
    goToWalletApple: 'GA NAAR APPLE WALLET',
    defaultTitle: 'Pas toevoegen aan Wallet',
    facingIssues: 'Problemen?',
    tryAgain: 'Probeer opnieuw',
  },
  ca: {
    scanFirstLine: 'Escaneja el codi QR',
    scanSecondLine: 'per afegir el passi a Wallet',
    building: "S'està creant el teu passi...",
    alreadyAddedGoogle: "El passi ja s'ha afegit a Google Wallet",
    alreadyAddedApple: "El passi ja s'ha afegit a Apple Wallet",
    notFound: "No s'ha trobat cap passi amb aquest identificador",
    passDeactivated: "El passi s'ha desactivat",
    generalError: 'Alguna cosa ha anat malament, torna-ho a provar més tard',
    successMessage:
      "Se't redirigirà al teu passi en breu. Afegeix-lo a la teva wallet.",
    goToWalletGoogle: 'VÉS A GOOGLE WALLET',
    goToWalletApple: 'VÉS A APPLE WALLET',
    defaultTitle: 'Afegeix el passi a Wallet',
    facingIssues: 'Tens problemes?',
    tryAgain: 'Torna-ho a provar',
  },
  az: {
    scanFirstLine: 'QR kodu skan edin',
    scanSecondLine: 'kartı Wallet-ə əlavə etmək üçün',
    building: 'Kartınız hazırlanır...',
    alreadyAddedGoogle: 'Kart artıq Google Wallet-ə əlavə edilib',
    alreadyAddedApple: 'Kart artıq Apple Wallet-ə əlavə edilib',
    notFound: 'Bu ID ilə kart tapılmadı',
    passDeactivated: 'Kart deaktiv edilib',
    generalError: 'Xəta baş verdi, zəhmət olmasa, sonra yenidən cəhd edin',
    successMessage:
      'Tezliklə kartınıza yönləndiriləcəksiniz. Zəhmət olmasa, onu Wallet-ə əlavə edin.',
    goToWalletGoogle: 'GOOGLE WALLET-Ə KEÇİN',
    goToWalletApple: 'APPLE WALLET-Ə KEÇİN',
    defaultTitle: 'Kartı Wallet-ə əlavə edin',
    facingIssues: 'Problem yaşayırsınız?',
    tryAgain: 'Yenidən cəhd edin',
  },
  bg: {
    scanFirstLine: 'Сканирайте QR кода',
    scanSecondLine: 'за да добавите пропуска в Wallet',
    building: 'Създаване на вашия пропуск...',
    alreadyAddedGoogle: 'Пропускът вече е добавен в Google Wallet',
    alreadyAddedApple: 'Пропускът вече е добавен в Apple Wallet',
    notFound: 'Не е намерен пропуск с този идентификатор',
    passDeactivated: 'Пропускът е деактивиран',
    generalError: 'Възникна грешка, моля, опитайте отново по-късно',
    successMessage:
      'Скоро ще бъдете пренасочени към вашия пропуск. Моля, добавете го в портфейла си.',
    goToWalletGoogle: 'КЪМ GOOGLE WALLET',
    goToWalletApple: 'КЪМ APPLE WALLET',
    defaultTitle: 'Добавяне на пропуск в Wallet',
    facingIssues: 'Имате проблем?',
    tryAgain: 'Опитайте отново',
  },
  hr: {
    scanFirstLine: 'Skenirajte QR kôd',
    scanSecondLine: 'za dodavanje propusnice u Wallet',
    building: 'Izrada vaše propusnice...',
    alreadyAddedGoogle: 'Propusnica je već dodana u Google Wallet',
    alreadyAddedApple: 'Propusnica je već dodana u Apple Wallet',
    notFound: 'Propusnica s ovim ID-om nije pronađena',
    passDeactivated: 'Propusnica je deaktivirana',
    generalError: 'Nešto je pošlo po zlu, pokušajte ponovno kasnije',
    successMessage:
      'Uskoro ćete biti preusmjereni na svoju propusnicu. Dodajte je u svoj novčanik.',
    goToWalletGoogle: 'OTVORI GOOGLE WALLET',
    goToWalletApple: 'OTVORI APPLE WALLET',
    defaultTitle: 'Dodaj propusnicu u Wallet',
    facingIssues: 'Imate poteškoća?',
    tryAgain: 'Pokušajte ponovno',
  },
  cs: {
    scanFirstLine: 'Naskenujte QR kód',
    scanSecondLine: 'pro přidání průkazu do Wallet',
    building: 'Vytváření vašeho průkazu...',
    alreadyAddedGoogle: 'Průkaz již byl přidán do Google Wallet',
    alreadyAddedApple: 'Průkaz již byl přidán do Apple Wallet',
    notFound: 'Průkaz s tímto ID nebyl nalezen',
    passDeactivated: 'Průkaz byl deaktivován',
    generalError: 'Něco se pokazilo, zkuste to prosím později',
    successMessage:
      'Brzy budete přesměrováni na svůj průkaz. Přidejte si jej prosím do peněženky.',
    goToWalletGoogle: 'PŘEJÍT DO GOOGLE WALLET',
    goToWalletApple: 'PŘEJÍT DO APPLE WALLET',
    defaultTitle: 'Přidat průkaz do Wallet',
    facingIssues: 'Máte potíže?',
    tryAgain: 'Zkusit znovu',
  },
  da: {
    scanFirstLine: 'Scan QR-koden',
    scanSecondLine: 'for at føje passet til Wallet',
    building: 'Opretter dit pass...',
    alreadyAddedGoogle: 'Passet er allerede føjet til Google Wallet',
    alreadyAddedApple: 'Passet er allerede føjet til Apple Wallet',
    notFound: 'Der blev ikke fundet et pass med dette ID',
    passDeactivated: 'Passet er blevet deaktiveret',
    generalError: 'Noget gik galt. Prøv igen senere',
    successMessage:
      'Du bliver omdirigeret til dit pass om et øjeblik. Føj det til din wallet.',
    goToWalletGoogle: 'GÅ TIL GOOGLE WALLET',
    goToWalletApple: 'GÅ TIL APPLE WALLET',
    defaultTitle: 'Føj pass til Wallet',
    facingIssues: 'Har du problemer?',
    tryAgain: 'Prøv igen',
  },
  et: {
    scanFirstLine: 'Skannige QR-koodi',
    scanSecondLine: 'et lisada pääse Walletisse',
    building: 'Sinu pääsme loomine...',
    alreadyAddedGoogle: 'Pääse on juba Google Walletisse lisatud',
    alreadyAddedApple: 'Pääse on juba Apple Walletisse lisatud',
    notFound: 'Selle ID-ga pääset ei leitud',
    passDeactivated: 'Pääse on deaktiveeritud',
    generalError: 'Midagi läks valesti, palun proovige hiljem uuesti',
    successMessage:
      'Teid suunatakse peagi teie pääsme juurde. Palun lisage see oma rahakotti.',
    goToWalletGoogle: 'AVA GOOGLE WALLET',
    goToWalletApple: 'AVA APPLE WALLET',
    defaultTitle: 'Lisa pääse Walletisse',
    facingIssues: 'Kas teil on probleeme?',
    tryAgain: 'Proovi uuesti',
  },
  fil: {
    scanFirstLine: 'I-scan ang QR code',
    scanSecondLine: 'para idagdag ang pass sa Wallet',
    building: 'Binubuo ang iyong pass...',
    alreadyAddedGoogle: 'Naidagdag na ang pass sa Google Wallet',
    alreadyAddedApple: 'Naidagdag na ang pass sa Apple Wallet',
    notFound: 'Walang nahanap na pass na may ganitong ID',
    passDeactivated: 'Na-deactivate na ang pass',
    generalError: 'May nangyaring mali, pakisubukan muli mamaya',
    successMessage:
      'Ire-redirect ka sa iyong pass sa ilang sandali. Pakidagdag ito sa iyong wallet.',
    goToWalletGoogle: 'PUMUNTA SA GOOGLE WALLET',
    goToWalletApple: 'PUMUNTA SA APPLE WALLET',
    defaultTitle: 'Idagdag ang pass sa Wallet',
    facingIssues: 'May problema ba?',
    tryAgain: 'Subukan muli',
  },
  fi: {
    scanFirstLine: 'Skannaa QR-koodi',
    scanSecondLine: 'lisätäksesi passin Lompakkoon',
    building: 'Luodaan passiasi...',
    alreadyAddedGoogle: 'Passi on jo lisätty Google Wallet -lompakkoon',
    alreadyAddedApple: 'Passi on jo lisätty Apple Wallet -lompakkoon',
    notFound: 'Tällä tunnuksella ei löytynyt passia',
    passDeactivated: 'Passi on poistettu käytöstä',
    generalError: 'Jotain meni pieleen, yritä myöhemmin uudelleen',
    successMessage:
      'Sinut ohjataan passiisi hetken kuluttua. Lisää se lompakkoosi.',
    goToWalletGoogle: 'SIIRRY GOOGLE WALLETIIN',
    goToWalletApple: 'SIIRRY APPLE WALLETIIN',
    defaultTitle: 'Lisää passi Lompakkoon',
    facingIssues: 'Onko ongelmia?',
    tryAgain: 'Yritä uudelleen',
  },
  el: {
    scanFirstLine: 'Σαρώστε τον κωδικό QR',
    scanSecondLine: 'για να προσθέσετε το pass στο Wallet',
    building: 'Δημιουργία του pass σας...',
    alreadyAddedGoogle: 'Το pass έχει ήδη προστεθεί στο Google Wallet',
    alreadyAddedApple: 'Το pass έχει ήδη προστεθεί στο Apple Wallet',
    notFound: 'Δεν βρέθηκε pass με αυτό το αναγνωριστικό',
    passDeactivated: 'Το pass έχει απενεργοποιηθεί',
    generalError: 'Κάτι πήγε στραβά, δοκιμάστε ξανά αργότερα',
    successMessage:
      'Θα ανακατευθυνθείτε στο pass σας σύντομα. Προσθέστε το στο wallet σας.',
    goToWalletGoogle: 'ΜΕΤΑΒΑΣΗ ΣΤΟ GOOGLE WALLET',
    goToWalletApple: 'ΜΕΤΑΒΑΣΗ ΣΤΟ APPLE WALLET',
    defaultTitle: 'Προσθήκη pass στο Wallet',
    facingIssues: 'Αντιμετωπίζετε προβλήματα;',
    tryAgain: 'Δοκιμάστε ξανά',
  },
  he: {
    scanFirstLine: 'סרקו את קוד ה-QR',
    scanSecondLine: 'כדי להוסיף את הכרטיס ל-Wallet',
    building: 'יוצרים את הכרטיס שלך...',
    alreadyAddedGoogle: 'הכרטיס כבר נוסף ל-Google Wallet',
    alreadyAddedApple: 'הכרטיס כבר נוסף ל-Apple Wallet',
    notFound: 'לא נמצא כרטיס עם מזהה זה',
    passDeactivated: 'הכרטיס הושבת',
    generalError: 'משהו השתבש, נסו שוב מאוחר יותר',
    successMessage: 'בקרוב תועברו לכרטיס שלך. הוסיפו אותו ל-Wallet שלכם.',
    goToWalletGoogle: 'מעבר ל-Google Wallet',
    goToWalletApple: 'מעבר ל-Apple Wallet',
    defaultTitle: 'הוספת כרטיס ל-Wallet',
    facingIssues: 'נתקלתם בבעיה?',
    tryAgain: 'נסו שוב',
  },
  hu: {
    scanFirstLine: 'Olvassa be a QR-kódot',
    scanSecondLine: 'a passz Wallethez adásához',
    building: 'A passz létrehozása folyamatban...',
    alreadyAddedGoogle: 'A passzt már hozzáadta a Google Wallethez',
    alreadyAddedApple: 'A passzt már hozzáadta az Apple Wallethez',
    notFound: 'Nem található passz ezzel az azonosítóval',
    passDeactivated: 'A passzt deaktiválták',
    generalError: 'Hiba történt, kérjük, próbálja újra később',
    successMessage:
      'Hamarosan átirányítjuk a passzához. Kérjük, adja hozzá a walletjéhez.',
    goToWalletGoogle: 'UGRÁS A GOOGLE WALLETHEZ',
    goToWalletApple: 'UGRÁS AZ APPLE WALLETHEZ',
    defaultTitle: 'Passz hozzáadása a Wallethez',
    facingIssues: 'Problémába ütközött?',
    tryAgain: 'Próbálja újra',
  },
  id: {
    scanFirstLine: 'Pindai kode QR',
    scanSecondLine: 'untuk menambahkan pass ke Wallet',
    building: 'Membuat pass Anda...',
    alreadyAddedGoogle: 'Pass sudah ditambahkan ke Google Wallet',
    alreadyAddedApple: 'Pass sudah ditambahkan ke Apple Wallet',
    notFound: 'Pass dengan ID ini tidak ditemukan',
    passDeactivated: 'Pass telah dinonaktifkan',
    generalError: 'Terjadi kesalahan, silakan coba lagi nanti',
    successMessage:
      'Anda akan segera diarahkan ke pass Anda. Silakan tambahkan ke wallet Anda.',
    goToWalletGoogle: 'BUKA GOOGLE WALLET',
    goToWalletApple: 'BUKA APPLE WALLET',
    defaultTitle: 'Tambahkan pass ke Wallet',
    facingIssues: 'Mengalami masalah?',
    tryAgain: 'Coba lagi',
  },
  lv: {
    scanFirstLine: 'Skenējiet QR kodu',
    scanSecondLine: 'lai pievienotu karti Wallet',
    building: 'Veidojam jūsu karti...',
    alreadyAddedGoogle: 'Karte jau ir pievienota Google Wallet',
    alreadyAddedApple: 'Karte jau ir pievienota Apple Wallet',
    notFound: 'Karte ar šo ID nav atrasta',
    passDeactivated: 'Karte ir deaktivizēta',
    generalError: 'Radās kļūda, lūdzu, mēģiniet vēlreiz vēlāk',
    successMessage:
      'Drīz jūs tiksiet novirzīts uz savu karti. Lūdzu, pievienojiet to savam Wallet.',
    goToWalletGoogle: 'ATVĒRT GOOGLE WALLET',
    goToWalletApple: 'ATVĒRT APPLE WALLET',
    defaultTitle: 'Pievienot karti Wallet',
    facingIssues: 'Radušās problēmas?',
    tryAgain: 'Mēģināt vēlreiz',
  },
  lt: {
    scanFirstLine: 'Nuskenuokite QR kodą',
    scanSecondLine: 'kad pridėtumėte bilietą į Wallet',
    building: 'Kuriamas jūsų bilietas...',
    alreadyAddedGoogle: 'Bilietas jau pridėtas į Google Wallet',
    alreadyAddedApple: 'Bilietas jau pridėtas į Apple Wallet',
    notFound: 'Bilietas su šiuo ID nerastas',
    passDeactivated: 'Bilietas deaktyvuotas',
    generalError: 'Įvyko klaida, bandykite dar kartą vėliau',
    successMessage:
      'Netrukus būsite nukreipti į savo bilietą. Pridėkite jį prie savo Wallet.',
    goToWalletGoogle: 'ATIDARYTI GOOGLE WALLET',
    goToWalletApple: 'ATIDARYTI APPLE WALLET',
    defaultTitle: 'Pridėti bilietą į Wallet',
    facingIssues: 'Kyla problemų?',
    tryAgain: 'Bandyti dar kartą',
  },
  nb: {
    scanFirstLine: 'Skann QR-koden',
    scanSecondLine: 'for å legge passet til i Wallet',
    building: 'Lager passet ditt...',
    alreadyAddedGoogle: 'Passet er allerede lagt til i Google Wallet',
    alreadyAddedApple: 'Passet er allerede lagt til i Apple Wallet',
    notFound: 'Fant ikke noe pass med denne ID-en',
    passDeactivated: 'Passet er deaktivert',
    generalError: 'Noe gikk galt, prøv igjen senere',
    successMessage:
      'Du blir snart videresendt til passet ditt. Legg det til i Wallet.',
    goToWalletGoogle: 'GÅ TIL GOOGLE WALLET',
    goToWalletApple: 'GÅ TIL APPLE WALLET',
    defaultTitle: 'Legg passet til i Wallet',
    facingIssues: 'Har du problemer?',
    tryAgain: 'Prøv igjen',
  },
  pl: {
    scanFirstLine: 'Zeskanuj kod QR',
    scanSecondLine: 'aby dodać przepustkę do Wallet',
    building: 'Tworzenie przepustki...',
    alreadyAddedGoogle: 'Przepustka została już dodana do Google Wallet',
    alreadyAddedApple: 'Przepustka została już dodana do Apple Wallet',
    notFound: 'Nie znaleziono przepustki o tym identyfikatorze',
    passDeactivated: 'Przepustka została dezaktywowana',
    generalError: 'Coś poszło nie tak, spróbuj ponownie później',
    successMessage:
      'Za chwilę nastąpi przekierowanie do Twojej przepustki. Dodaj ją do swojego Wallet.',
    goToWalletGoogle: 'PRZEJDŹ DO GOOGLE WALLET',
    goToWalletApple: 'PRZEJDŹ DO APPLE WALLET',
    defaultTitle: 'Dodaj przepustkę do Wallet',
    facingIssues: 'Masz problemy?',
    tryAgain: 'Spróbuj ponownie',
  },
  'pt-BR': {
    scanFirstLine: 'Escaneie o QR code',
    scanSecondLine: 'para adicionar o passe à Carteira',
    building: 'Gerando seu passe...',
    alreadyAddedGoogle: 'O passe já foi adicionado à Carteira do Google',
    alreadyAddedApple: 'O passe já foi adicionado à Apple Wallet',
    notFound: 'Nenhum passe encontrado com este ID',
    passDeactivated: 'O passe foi desativado',
    generalError: 'Algo deu errado, tente novamente mais tarde',
    successMessage:
      'Você será redirecionado para o seu passe em instantes. Adicione-o à sua carteira.',
    goToWalletGoogle: 'IR PARA A CARTEIRA DO GOOGLE',
    goToWalletApple: 'IR PARA A APPLE WALLET',
    defaultTitle: 'Adicionar passe à Carteira',
    facingIssues: 'Está com problemas?',
    tryAgain: 'Tentar novamente',
  },
  ro: {
    scanFirstLine: 'Scanează codul QR',
    scanSecondLine: 'pentru a adăuga tichetul în Wallet',
    building: 'Se creează tichetul tău...',
    alreadyAddedGoogle: 'Tichetul a fost deja adăugat în Google Wallet',
    alreadyAddedApple: 'Tichetul a fost deja adăugat în Apple Wallet',
    notFound: 'Nu s-a găsit niciun tichet cu acest ID',
    passDeactivated: 'Tichetul a fost dezactivat',
    generalError: 'A apărut o problemă, te rugăm să încerci din nou mai târziu',
    successMessage:
      'Vei fi redirecționat către tichetul tău în scurt timp. Adaugă-l în portofelul tău.',
    goToWalletGoogle: 'MERGI LA GOOGLE WALLET',
    goToWalletApple: 'MERGI LA APPLE WALLET',
    defaultTitle: 'Adaugă tichetul în Wallet',
    facingIssues: 'Întâmpini probleme?',
    tryAgain: 'Încearcă din nou',
  },
  ru: {
    scanFirstLine: 'Отсканируйте QR-код',
    scanSecondLine: 'чтобы добавить пропуск в Wallet',
    building: 'Создаём ваш пропуск...',
    alreadyAddedGoogle: 'Пропуск уже добавлен в Google Wallet',
    alreadyAddedApple: 'Пропуск уже добавлен в Apple Wallet',
    notFound: 'Пропуск с таким ID не найден',
    passDeactivated: 'Пропуск деактивирован',
    generalError: 'Что-то пошло не так, пожалуйста, попробуйте позже',
    successMessage:
      'Скоро вы будете перенаправлены к вашему пропуску. Добавьте его в свой кошелёк.',
    goToWalletGoogle: 'ПЕРЕЙТИ В GOOGLE WALLET',
    goToWalletApple: 'ПЕРЕЙТИ В APPLE WALLET',
    defaultTitle: 'Добавить пропуск в Wallet',
    facingIssues: 'Возникли проблемы?',
    tryAgain: 'Попробовать снова',
  },
  sk: {
    scanFirstLine: 'Naskenujte QR kód',
    scanSecondLine: 'a pridajte preukaz do Wallet',
    building: 'Vytvárame váš preukaz...',
    alreadyAddedGoogle: 'Preukaz už bol pridaný do Google Wallet',
    alreadyAddedApple: 'Preukaz už bol pridaný do Apple Wallet',
    notFound: 'Preukaz s týmto ID sa nenašiel',
    passDeactivated: 'Preukaz bol deaktivovaný',
    generalError: 'Niečo sa pokazilo, skúste to znova neskôr',
    successMessage:
      'Onedlho budete presmerovaní na váš preukaz. Pridajte si ho do peňaženky.',
    goToWalletGoogle: 'PREJSŤ DO GOOGLE WALLET',
    goToWalletApple: 'PREJSŤ DO APPLE WALLET',
    defaultTitle: 'Pridať preukaz do Wallet',
    facingIssues: 'Máte problémy?',
    tryAgain: 'Skúsiť znova',
  },
  sl: {
    scanFirstLine: 'Skenirajte kodo QR',
    scanSecondLine: 'za dodajanje vstopnice v Wallet',
    building: 'Ustvarjamo vašo vstopnico...',
    alreadyAddedGoogle: 'Vstopnica je že dodana v Google Wallet',
    alreadyAddedApple: 'Vstopnica je že dodana v Apple Wallet',
    notFound: 'Vstopnice s tem ID-jem ni mogoče najti',
    passDeactivated: 'Vstopnica je bila deaktivirana',
    generalError: 'Prišlo je do napake, poskusite znova pozneje',
    successMessage:
      'Kmalu boste preusmerjeni na svojo vstopnico. Dodajte jo v svojo denarnico.',
    goToWalletGoogle: 'POJDI V GOOGLE WALLET',
    goToWalletApple: 'POJDI V APPLE WALLET',
    defaultTitle: 'Dodaj vstopnico v Wallet',
    facingIssues: 'Imate težave?',
    tryAgain: 'Poskusite znova',
  },
  sv: {
    scanFirstLine: 'Skanna QR-koden',
    scanSecondLine: 'för att lägga till passet i Wallet',
    building: 'Skapar ditt pass...',
    alreadyAddedGoogle: 'Passet har redan lagts till i Google Wallet',
    alreadyAddedApple: 'Passet har redan lagts till i Apple Wallet',
    notFound: 'Inget pass med detta ID hittades',
    passDeactivated: 'Passet har inaktiverats',
    generalError: 'Något gick fel, försök igen senare',
    successMessage:
      'Du bör omdirigeras till ditt pass inom kort. Lägg till det i din wallet.',
    goToWalletGoogle: 'GÅ TILL GOOGLE WALLET',
    goToWalletApple: 'GÅ TILL APPLE WALLET',
    defaultTitle: 'Lägg till pass i Wallet',
    facingIssues: 'Har du problem?',
    tryAgain: 'Försök igen',
  },
  th: {
    scanFirstLine: 'สแกนคิวอาร์โค้ด',
    scanSecondLine: 'เพื่อเพิ่มพาสลงใน Wallet',
    building: 'กำลังสร้างพาสของคุณ...',
    alreadyAddedGoogle: 'เพิ่มพาสลงใน Google Wallet เรียบร้อยแล้ว',
    alreadyAddedApple: 'เพิ่มพาสลงใน Apple Wallet เรียบร้อยแล้ว',
    notFound: 'ไม่พบพาสที่มีรหัสนี้',
    passDeactivated: 'พาสนี้ถูกปิดใช้งานแล้ว',
    generalError: 'เกิดข้อผิดพลาด โปรดลองอีกครั้งภายหลัง',
    successMessage:
      'คุณจะถูกนำไปยังพาสของคุณในไม่ช้า โปรดเพิ่มลงใน Wallet ของคุณ',
    goToWalletGoogle: 'ไปที่ Google Wallet',
    goToWalletApple: 'ไปที่ Apple Wallet',
    defaultTitle: 'เพิ่มพาสลงใน Wallet',
    facingIssues: 'พบปัญหาอยู่ใช่ไหม?',
    tryAgain: 'ลองอีกครั้ง',
  },
  tr: {
    scanFirstLine: 'QR kodunu tarayın',
    scanSecondLine: "kartı Cüzdan'a eklemek için",
    building: 'Kartınız oluşturuluyor...',
    alreadyAddedGoogle: "Kart zaten Google Cüzdan'a eklendi",
    alreadyAddedApple: "Kart zaten Apple Cüzdan'a eklendi",
    notFound: 'Bu kimliğe sahip kart bulunamadı',
    passDeactivated: 'Kart devre dışı bırakıldı',
    generalError: 'Bir şeyler ters gitti, lütfen daha sonra tekrar deneyin',
    successMessage:
      'Kısa süre içinde kartınıza yönlendirileceksiniz. Lütfen kartı cüzdanınıza ekleyin.',
    goToWalletGoogle: "GOOGLE CÜZDAN'A GİT",
    goToWalletApple: "APPLE CÜZDAN'A GİT",
    defaultTitle: "Kartı Cüzdan'a ekle",
    facingIssues: 'Sorun mu yaşıyorsunuz?',
    tryAgain: 'Tekrar deneyin',
  },
  uk: {
    scanFirstLine: 'Відскануйте QR-код',
    scanSecondLine: 'щоб додати пас до Wallet',
    building: 'Створення вашого пасу...',
    alreadyAddedGoogle: 'Пас уже додано до Google Wallet',
    alreadyAddedApple: 'Пас уже додано до Apple Wallet',
    notFound: 'Пас із цим ідентифікатором не знайдено',
    passDeactivated: 'Пас деактивовано',
    generalError: 'Щось пішло не так, спробуйте ще раз пізніше',
    successMessage:
      'Незабаром вас буде перенаправлено до вашого пасу. Додайте його до свого Wallet.',
    goToWalletGoogle: 'ПЕРЕЙТИ ДО GOOGLE WALLET',
    goToWalletApple: 'ПЕРЕЙТИ ДО APPLE WALLET',
    defaultTitle: 'Додати пас до Wallet',
    facingIssues: 'Виникли проблеми?',
    tryAgain: 'Спробувати ще раз',
  },
  'zh-HK': {
    scanFirstLine: '掃描 QR 碼',
    scanSecondLine: '即可將票證加入錢包',
    building: '正在建立你的票證...',
    alreadyAddedGoogle: '票證已加入 Google 錢包',
    alreadyAddedApple: '票證已加入 Apple 錢包',
    notFound: '找不到此 ID 的票證',
    passDeactivated: '票證已停用',
    generalError: '發生錯誤，請稍後再試',
    successMessage: '系統將很快帶你前往你的票證，請將它加入你的錢包。',
    goToWalletGoogle: '前往 Google 錢包',
    goToWalletApple: '前往 Apple 錢包',
    defaultTitle: '將票證加入錢包',
    facingIssues: '遇到問題嗎？',
    tryAgain: '再試一次',
  },
  'zh-TW': {
    scanFirstLine: '掃描 QR 碼',
    scanSecondLine: '即可將票證加入錢包',
    building: '正在建立您的票證...',
    alreadyAddedGoogle: '票證已加入 Google 錢包',
    alreadyAddedApple: '票證已加入 Apple 錢包',
    notFound: '找不到此 ID 的票證',
    passDeactivated: '票證已停用',
    generalError: '發生錯誤，請稍後再試',
    successMessage: '系統將很快帶您前往您的票證，請將它加入您的錢包。',
    goToWalletGoogle: '前往 Google 錢包',
    goToWalletApple: '前往 Apple 錢包',
    defaultTitle: '將票證加入錢包',
    facingIssues: '遇到問題嗎？',
    tryAgain: '再試一次',
  },
};
